// extracted by mini-css-extract-plugin
module.exports = {"button":"PlayPauseButton_button__RaKfX","pause":"PlayPauseButton_pause__k_N38","play":"PlayPauseButton_play__qnW0w"};